import {Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UtilitiesService } from '../utilities/utilities.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from '../services/product.service';
import { NgStyle } from '@angular/common';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
@Component({
  selector: 'app-roaming-countries-partners',
  templateUrl: './roaming-countries-partners.component.html',
  styleUrls: ['./roaming-countries-partners.component.scss']
  
})
export class RoamingCountriesPartnersComponent implements OnInit {
  @Input('data') data: any;
  @Input('type') type: any;
  countries: any;
  backupCountries: any;
  sku:any;
  parentCategory:any='';
  lang:any='';
  selectedcountry;
  id:any;
  countryName:any;
  countryImage:any;
  isPrefferedPartner=[];
  nonPrefferedParner=[];
  roamingCharges='';
  constructor(
    public modalController: ModalController,
    private UTS: UtilitiesService,
    private translate: TranslateService,
    private PS: ProductService,
    private GAS: GoogleAnalyticsService
  ) { }

  ngOnInit(): void {
    this.countries = this.countries;
    this.sku = this.data?.sku;
    this.backupCountries = JSON.parse(JSON.stringify(this.data?.countries || ''));
    this.parentCategory = localStorage.getItem('ParentCategory') || '';
    this.lang = this.data?.lang;
    this.getRoamingPartners(this.data?.id);
  }
  getRoamingPartners(id)
  {
    this.PS.getRoamingCountries(id).subscribe((res:any)=>{
    
      if(this.lang=='en')
      {
        this.countryName=res.countryName;
      }
      else if (this.lang=='ar')
      {
        this.countryName=res.nameAr;

      }
        
        this.countryImage=res.image;
        this.roamingCharges=res.roamingCharges;
        this.roamingCharges=this.roamingCharges?.substring(1);
      if(res?.roamingPartners!=null)
      {
      //  this.selectedCountry = {...country,roamingPartners:res?.roamingPartners}
       this.nonPrefferedParner= res.roamingPartners.filter(x=>x.preferred==false);
    
     this.isPrefferedPartner= res.roamingPartners.filter(x=>x.preferred==true);
    //  this.modalController.dismiss( this.selectedCountry);
    this.onRoamingPartnersGA(this.countryName);
      }
      else{
      //  this.selectedCountry = {...country,roamingPartners:[]};
    //    this.modalController.dismiss( this.selectedCountry);
 
      }
    })
 
  }
  onRoamingPartnersGA(countryName)
  {
    let typeOfRoaming='';
    if(this.nonPrefferedParner.length>0&& this.isPrefferedPartner.length>0)
    {
      typeOfRoaming='Preffered and Non-Preferred' ;
    }
    else if(this.nonPrefferedParner.length>0)
    {
      typeOfRoaming='Non-Preferred';
    }
    else if(this.isPrefferedPartner.length>0)
    {
      typeOfRoaming='Preferred'
    }
    let modal_data={
      event:'b2b_fire_event',
      eventCategory:'roaming',
      eventAction:'Roaming partners and Charges -load ',
      eventLabel:countryName,
      typesOfRoaming:typeOfRoaming,
      user_env:this.UTS.getENV()
    }
    this.GAS.countrySearch_Roaming(modal_data);
  }
  goBack()
  {
    this.dismiss();
  }
  async filterList(evt) {
    this.countries = this.backupCountries;
    const searchTerm = evt.srcElement.value;
  
    if (!searchTerm) {
      return;
    }
  
    this.countries = this.countries.filter(currentFood => {
      if (currentFood.countryName && searchTerm) {
        return (currentFood.countryName.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1)
      }
    });
  }

  dismiss(){
    this.modalController.dismiss();
  }

  replaceNumber(data:any){
    const value :any =  data & data.replace(/^0+/, '') || ''; 
    return  value;
  }
}